import styled from 'styled-components';

export const DashboardWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 10px;
`;

export const ButtonWrapper = styled.div`
  margin-right: 4px;
`;

export const ContentWrapper = styled.div``;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  vertical-align: middle;
  margin-left: 400px;
  margin-right: 400px;
`;

export const TableWrapper = styled.div`
  margin-left: 100px;
  margin-right: 100px;
`;

export const ControlButtonWrapper = styled.div`
  margin-left: 20px;
  display: flex;
  flex-direction: row;
  width: 200px;
`;

export const ActionButtons = styled.button`
  border: none;
  border-radius: 3px;
  width: 150px;
  height: 50px;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-right: 20px;
  padding: 15px 18px;
  cursor: pointer;
  color: #000;
  background-color: ${props => (props.success ? '#97ca8a' : '#f7655e')};
  font-weight: 500;
  background-position: center;
  &:hover {
    background: #ccc radial-gradient(circle, transparent 1%, #616161 1%)
      center/15000%;
  }
  &:active {
    background-color: #ccc;
    background-size: 100%;
    transition: background 0s;
  }
`;

export const UserLabel = styled.div`
  text-align: center;
  color: #000;
  line-height: 60px;
  font-size: 21px;
  font-weight: 400;
`;

export const NormalText = styled.div`
  text-align: center;
  color: #000;
  line-height: 60px;
  font-size: 14px;
  font-weight: 200;
`;

export const CardSubText = styled.div`
  color: #000;
  margin-top: 20px;
  font-size: 14px;
  font-weight: 200;
`;

export const WideNormalText = styled.div`
  text-align: center;
  color: #000;
  line-height: 60px;
  font-size: 20px;
  font-weight: 700;
`;

export const AlertWrapper = styled.div`
  text-align: center;
  margin-left: 100px;
  margin-right: 100px;
`;
